import { parseDate } from '@/utils/date_manipulation'

export const state = () => ({
  weeksList: {},
  resources: [],
  currentResource: null
})

export const mutations = {
  setWeeksList(state, newWeekList) {
    state.weeksList = {...state.weeksList, ...newWeekList}
  },

  setResources(state, newResources) {
    state.resources = [...newResources]
  },

  addResources(state, newResources) {
    state.resources = [...state.resources, ...newResources]
  },

  removeResource(state, resourceId) {
    state.resources = state.resources.filter(({ id }) => id !== resourceId)
  },

  setResourceDiscarded(state, resourceId) {
    state.resources.forEach(res => {
      if(res.id === resourceId)
        res.setDiscarded()
    })
  },

  setResourceReady(state, resourceId) {
    state.resources.forEach(res => {
      if(res.id === resourceId)
        res.setReady()
    })
  },

  setResourceArchived(state, resourceId) {
    state.resources.forEach(res => {
      if(res.id === resourceId)
        res.setEnqueued()
    })
  },

  setCurrentResource(state, newCurrentResource) {
    state.currentResource =  { ...newCurrentResource }
  }
}

export const actions = {
  setResourceDiscarded({ commit }, { resource, showDiscarded }) {
    commit('setResourceDiscarded', resource.id)
    if (!showDiscarded)
      commit('removeResource', resource.id)
  },

  setResourceReady({ commit }, resource) {
    commit('setResourceReady', resource.id)
  },

  setResourceArchived({ commit }, resource) {
    commit('setResourceArchived', resource.id)
  }
}

export const getters = {
  weeksList(state) {
    return state.weeksList
  },

  weekListByDates: (state) => (weekStart, weekEnd) => {
    return Object.keys(state.weeksList)
                 .filter(key_date => ( parseDate({ date: key_date }).isBetween(weekStart, weekEnd, null, '[]') ))
                 .map(key_date => ({ ...state.weeksList[key_date] }))
                 .filter(obj => (obj || {}).social)
                 .reduce((accomulator, item) => {
                   accomulator.social = accomulator.social || {}
                   Object.keys(item.social || {}).forEach(k => {
                     accomulator.social[k] = (accomulator.social[k] || 0) + item.social[k]
                   })
                   return accomulator
                 }, {})
  },

  resources: (state) => state.resources,

  currentResource: (state) => state.currentResource
}